import Immutable from 'immutable';
import thunker from 'redux-thunk';
import logging from './middleware/logging';
import tracker from './middleware/tracker';
import jsonapi from './middleware/jsonapi';
import catcher from './middleware/catcher';
import { reducer } from './reducers';
import
{
	createStore, 
	applyMiddleware,
	compose
} from 'redux';

const createProductionStore = compose(
	applyMiddleware(thunker, jsonapi),
  applyMiddleware(tracker, logging),
	applyMiddleware(catcher)
)(createStore);

// export default (state = Immutable.Map()) => createDevelopmentStore(reducer, state);
export default (state = Immutable.Map()) => createProductionStore(reducer, state);




/** WEBPACK FOOTER **
 ** ./app/store.js
 **/